<template>
  <div
    style="background: black"
    :class="{
      debug: debug,
      fixed: single,
      single: single,
      multiple: !single
    }"
    :style="{
      top: marginVertical + 'px ',
      bottom: marginVertical + 'px ',
      left: +marginHorizontal + 'px',
      right: +marginHorizontal + 'px'
    }"
  >
    <warning-message
      v-if="!screen.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <warning-message
      v-else-if="todaysNowPlayingAndUpcomingShowings.length == 0"
    >
      {{ $t('showing.noShowingsToday') }}
    </warning-message>
    <div v-else-if="screen && currentShowing">
      <!-- We have a movie and showtimes-->
      <div
        class="column justify-between"
        :class="{ 'absolute-full': single }"
      >
        <div class="q-my-md">
          <div
            v-if="showScreenName || !single"
            class="row justify-evenly items-center text-bold"
            :style="{
              color: screen.color,
              'font-size': !single ? '3.5vw' : '56px'
            }"
          >
            {{ screen.name }}
          </div>
          <div
            v-if="showMovieName"
            class="row justify-evenly items-center"
            :class="!single || showScreenName ? '' : 'text-bold'"
            :style="{ color: !single ? screen.color : '#ffffff' }"
            style="font-size: 56px;"
          >
            {{ currentShowing.movie.name }}
          </div>
        </div>
        <video
          v-if="single && currentShowing.movie.animatedPosterVideo"
          :key="currentShowing.movie.id"
          autoplay
          loop
          muted
          style="width: 100%; height: 100%; object-fit: cover;"
          class="col q-mb-md"
        >
          <source
            :src="currentShowing.movie.animatedPosterVideoUrl"
            type="video/mp4"
          >
        </video>
        <q-img
          v-else-if="single"
          class="col q-mb-md"
          :src="currentShowing.movie.posterImageLargeUrl"
        />
        <div
          v-else
          class="col q-mb-md q-mx-xl q-px-md poster overflow-hidden"
        >
          <q-img
            class="poster"
            :style="overridePosterHeight ? `height: ${overridePosterHeight}vh; max-height: ${overridePosterHeight}vh;` : ''"
            :src="currentShowing.movie.posterImageLargeUrl"
          />
        </div>
        <div
          class="col-auto row justify-between q-mx-md q-mb-md"
          :class="single ? '' : 'q-px-md'"
        >
          <div class="col-auto row items-center">
            <template v-if="currentSite.signageDisplayRating">
              <rated
                v-if="currentShowing.movie.rating"
                :rated="currentShowing.movie.rating"
                :rating-reason="currentShowing.movie.ratingReason"
                :outline="false"
                :color="'transparent'"
                :text-color="'white'"
                :font-size="27"
                light-text
                :highlight-r-rated="highlightRRated"
                :disable-official-symbol="disableOfficialSymbol"
                class="text-bold q-pr-xl"
              />
              <q-chip
                v-if="currentShowing.movie.ratingReason && showRatingReason"
                square
                color="transparent"
                text-color="white"
                size="lg"
                class="text-bold q-px-sm q-mr-lg"
                style="border: solid 2px; font-size: 26px; height: 50%"
                :label="currentShowing.movie.ratingReason"
              />
            </template>
            <template v-if="showShowingBadges">
              <showing-badge
                v-for="showingBadge in currentShowing.showingBadges.data"
                :key="showingBadge.id"
                class="col-auto"
                :size="single ? 'lg' : 'md'"
                :showing-badge="showingBadge"
                color="white"
              />
            </template>
          </div>
          <div class="col-auto q-ma-sm text-white text-h5">
            Ends {{ currentShowing.siteEndTime.format("h:mm a") }}
          </div>
        </div>
        <div
          v-if="detail"
          class="row justify-evenly items-center text-uppercase"
          :style="single ? '' : 'padding-bottom: 100px'"
        >
          <q-icon
            v-if="moreBefore"
            name="chevron_left"
            class="text-white before-after"
          />
          <div
            v-for="showing in showings()"
            :key="showing.showingId"
            class="col-auto showing"
            :style="styleForShowing(showing)"
          >
            <div class="time">
              {{ showing.siteTime.format("h:mm a") }}
            </div>
            <div
              v-if="multipleMovies"
              class="movie-name"
            >
              {{ showing.movie.name }}
            </div>
          </div>
          <q-icon
            v-if="moreAfter"
            name="chevron_right"
            class="text-white before-after"
          />
        </div>
        <div
          v-else
          class="row justify-evenly items-center text-uppercase"
          :style="single ? '' : 'padding-bottom: 100px'"
        >
          <div
            class="text-overline text-center text-white q-mt-lg"
            style="font-size: 72px; font-weight: 800"
            :class="single ? 'q-mb-lg' : ''"
          >
            {{ currentShowing.siteTime.format('h:mma') }}
          </div>
        </div>
      </div>
      <div
        v-if="screen && single && showScreenName"
        class="screen-name text-grey-7"
      >
        {{ screen.name }}
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      An error occurred
    </warning-message>
    <warning-message
      v-else-if="!screen"
    >
      {{ `Unknown Screen - ${$route.params && $route.params.screenId}` }}
    </warning-message>
    <warning-message
      v-else
    >
      Unknown Error
    </warning-message>
  </div>
</template>

<script>
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import Rated from 'src/modules/consumer/components/Rated'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import CurrentShowingsSignageMixin from 'src/modules/signage/mixins/CurrentShowingsSignageMixin'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'

export default {
  name: 'Screen',
  components: {
    ShowingBadge,
    Rated,
    WarningMessage
  },
  mixins: [CurrentShowingsSignageMixin, ShowingsSignageConfigurationMixin],
  props: {
    overrideScreenId: {
      type: Number,
      required: false,
      default: null
    },
    overrideCover: {
      type: Boolean,
      required: false,
      default: false
    },
    overridePosterHeight: {
      type: String,
      default: null,
      required: false
    },
    showMovieName: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-movie-name'] === 'false')
      }
    },
    showShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-showing-badges'] === 'false')
      }
    },
    showRatingReason: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-rating-reason'] === 'false')
      }
    }
  },
  emits: ['no-showings', 'has-showings'],
  models: {
    screen: {
      fields: ['id', 'name', 'color'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default'
      },
      variables () {
        return {
          id: this.overrideScreenId || this.$route.params?.screenId
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      errorOccurred: false,
      moreBefore: false,
      moreAfter: false
    }
  },
  computed: {
    multipleMovies () {
      return _(this.screen.todaysShowings.data).map('movie.id').uniq().value().length > 1
    },
    single () {
      return !this.overrideScreenId
    },
    detail () {
      return this.$route.query.detail === 'true'
    },
    showScreenName () {
      return this.$route.query['show-screen-name'] === 'true'
    },
    cover () {
      return this.overrideCover || this.$route.query.cover || false
    }
  },
  watch: {
    todaysNowPlayingAndUpcomingShowings: {
      handler (newShowings) {
        if (this.screen.loaded) {
          if (_.isEmpty(newShowings)) {
            this.$emit('no-showings')
          } else {
            this.$emit('has-showings')
          }
        }
      },
      deep: true,
      immediate: true
    },
    'screen.loaded': {
      handler (isLoaded) {
        if (isLoaded) {
          if (_.isEmpty(this.todaysNowPlayingAndUpcomingShowings)) {
            this.$emit('no-showings')
          } else {
            this.$emit('has-showings')
          }
        }
      },
      immediate: true
    }
  },
  async mounted () {
    this.intervalId = setInterval(() => {
      this.screen.fetch(true)
    }, 5 * 60 * 1000)

    await this.screen.fetch()

    // Fetching the screen when in the app mode of digital-signage, sets the site_id cookie
    // This will reload the configuration data after being authenticated
    this.$handleAuthChange()
  },
  unmounted () {
    if (this.intervalId) clearInterval(this.intervalId)
  },
  methods: {
    styleForShowing (showing) {
      let colorSuffix = ''
      let backgroundSuffix = ''
      let borderSize = '0.25vw'

      let color = this.$lightenColor(showing.movie.color || '#555', 70)
      let backgroundColor = this.$lightenColor(showing.movie.color || '#555', -50)

      if (showing.current) {
        // Current
        borderSize = '0.5vw'
      } else if (showing.localPast) {
        // Past
        colorSuffix = '55'
        backgroundSuffix = '55'
      } else {
        // Future
        colorSuffix = ''
        backgroundSuffix = '99'
      }

      let width
      if (this.single) {
        width = '21vw'
      } else {
        width = '6.5vw'
      }

      color = color + colorSuffix
      backgroundColor = backgroundColor + backgroundSuffix

      return 'width: ' + width + '; color: ' + color + '; background-color: ' + backgroundColor + ';' + 'border: solid ' + borderSize + ' ' + color
    },
    showings () {
      const now = new Date()

      let showings = [...this.screen.todaysShowings.data]

      let moreBefore = false
      let moreAfter = false

      while (showings.length > 3) {
        if (showings[0].endTime < now) {
          showings = showings.slice(1)
          moreBefore = true
        } else {
          showings = showings.slice(0, showings.length - 1)
          moreAfter = true
        }
      }

      this.moreBefore = moreBefore
      this.moreAfter = moreAfter

      return showings
    }
  }
}
</script>

<style scoped>

.debug .poster-and-showings-container > div {
  border: solid 1px red;
}

.showing {
  border-radius: 0.2vw;

  padding: 0.5vw 0.2vw;
  overflow: hidden;

  margin-left: 0.2vw;
  margin-right: 0.2vw;
  margin-bottom: 0.5vw;
}

.single .showing {
  border-radius: 1vw;

  padding: 2vw 1vw;
  overflow: hidden;

  margin-left: 1vw;
  margin-right: 1vw;
  margin-bottom: 3vw;
}
.before-after {
  font-size: 1vw;
  font-weight: bold;
  margin-bottom: 1vw;
}
.single .before-after {
  font-size: 4vw;
  font-weight: bold;
  margin-bottom: 3vw;
}
.debug .showing {
  border: solid 1px yellow;
}
.current {
  color: #1e57ff;
}
.past {
  color: #444;
}

.time {
  font-size: 0.8vw;
  font-weight: 800;
  line-height: 1vw;
}

.single .time {
  font-size: 3.5vw;
  font-weight: 800;
  line-height: 5vw;
}

.movie-name {
  padding-top: 0.3vw;
  font-size: 0.5vw;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  line-height: 0.5vw;
}

.single .movie-name {
  padding-top: 1vw;
  font-size: 2vw;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  line-height: 2vw;
}

.screen-name {
  font-size: 1.5vw;
  color: #333;
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 3px;
}

.screen-title {
  font-size: 3.5vw;
  font-weight: 800;
}

.multiple .poster {
  height: 72vh;
  max-height: 72vh;
}
</style>
